/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{PackedLayout as e,InterleavedLayout as r}from"./InterleavedLayout.js";function u(r,u){return u.push(r.buffer),{buffer:r.buffer,layout:new e(r.layout)}}function t(e){return new r(e.layout).createView(e.buffer)}export{u as packInterleavedBuffer,t as unpackInterleavedBuffer};
